import React, { FC } from "react";
import { css } from "@emotion/css";

import useTheme from "evcharging/hooks/useTheme";
import { Theme } from "evcharging/app/themes";

interface RatesCheckboxProps {
  checked: boolean;
  label?: string;
  onChange: (checked: boolean) => void;
}

const RatesCheckbox: FC<RatesCheckboxProps> = (props) => {
  const { checked, onChange, label } = props;
  const theme = useTheme();
  const classes = createStyles(theme);

  const onClick = () => {
    onChange(!checked);
  };

  return (
    <div className={classes.root}>
      <button className={classes.button} onClick={onClick}>
        {checked && <div className={classes.marker} />}
      </button>
      {label && <label>{label}</label>}
    </div>
  );
};

const createStyles = (_: Theme) => ({
  root: css({
    display: "flex",
    alignItems: "center",
    fontSize: 16,
  }),
  button: css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px #aaa solid",
    borderRadius: 3,
    background: "#fff",
    width: 20,
    height: 20,
    margin: 5,
    cursor: 'pointer',
  }),
  marker: css({
    width: "77%",
    height: "77%",
    background: '#aaa',
    borderRadius: 2
  })
});

export default RatesCheckbox;